import { Pressable, TextInput, View } from "react-native";
import { fp, hp, spH, spV, wp } from "utils/normalizeV2";

import VText from "components/VText";
import { useState } from "react";

const TextAreaInput = ({ item, prefAnswers = [], setPrefAnswers = () => {}, answerkey = "textarea" }) => {
    return (
        <View
            style={{
                marginBottom: spV(16),
            }}
        >
            <VText
                text={item?.question}
                style={{
                    fontSize: fp(16),
                    paddingBottom: hp(16),
                    fontWeight: "500",
                }}
            />

            <TextInput
                value={prefAnswers?.[answerkey] || ""}
                style={{
                    fontFamily: "JosefinSans",
                    color: "rgba(33, 36, 39, 1)",
                    fontSize: fp(16),
                    fontWeight: "350",
                    lineHeight: fp(24),
                    backgroundColor: "white",
                    borderWidth: 1,
                    borderColor: "rgba(33, 36, 39, 1)",
                    width: "100%",
                    height: hp(80),
                    verticalAlign: "top",
                    paddingHorizontal: spH(16),
                    paddingVertical: spV(8),
                    outlineStyle: "none",
                }}
                placeholder="Please write if you have any additional notes to share."
                placeholderTextColor={"rgba(33, 36, 39, 0.3)"}
                multiline
                onChangeText={(txt) => {
                    setPrefAnswers((prev) => ({
                        ...prev,
                        [answerkey]: txt,
                    }));
                }}
            />
        </View>
    );
};

export default TextAreaInput;
